import React from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Navigate} from 'react-router';

import Text from 'dc/content/Text';
import Grid from '@mui/material/Grid';

import NextSignInForm from './../forms/NextSignInForm';
import {doSendPin,doSubmitPin} from './../actions/mbox-and-pin-actions';
import ContentBlockHeader from 'dc/components/surface/ContentBlockHeader';
import ContainerX from 'dc/components/layout/ContainerX';
import InternalLink from 'dc/components/links/InternalLink';
import ResponsiveDialog from 'dc/components/dialogs/ResponsiveDialog';
//
import Error from 'dcx/app/common/Error';
import Success from 'dcx/app/common/Success';
//
import {RequestStatus} from 'dcx/app/util/RequestConstants';
//
import {FormattedMessage} from 'react-intl';
//
import {nextAuthenticationMessages} from './../i18n/NextAuthenticationMessages';
import ContentBlock from 'dc/components/surface/ContentBlock';


const extractError = (operationStatus, itemSelector) => {
    let itemsArray = [];
    if (RequestStatus.REJECTED == operationStatus) {
        operationStatus.data.forEach(item => {
            if (itemSelector(item)) {
                itemsArray.push(item)
            }
        })
    }
    return itemsArray;
}

const extractErrorOnSignin = operationStatus => {
    return extractError(operationStatus, item => {
        return true;
    })
}

const extractMBoxPasswordErrorOnSignin = operationStatus => {
    return extractError(operationStatus, item => {
        if ('USER_NOT_FOUND' == item.name) {
            return true;
        }
        return false;
    })
}

const extractCriticalErrorOnSignin = operationStatus => {
    return extractError(operationStatus, item => {
        if ('NOT_AUTHORISED_FOR_DOMAIN' == item.name) {
            return true;
        }
        return false;
    })
}

class NextSignInContainer extends React.Component {

    getSignInMessage() {
        const {submitPinStatus} = this.props;
        if (RequestStatus.NONE == submitPinStatus) {
            return null;
        }
        if (RequestStatus.ACTIVE == submitPinStatus) {
            return null;
        }
        if (RequestStatus.REJECTED == submitPinStatus) {
            let errorOnSignin = extractErrorOnSignin(submitPinStatus);
            if (0 < errorOnSignin.length) {
                return (
                    <Error message={`REJECTED ${errorOnSignin[0].name}`}/>
                )
            }
            return (
                <Error message={'REJECTED - unknown error'}/>
            )
        }
        return (
            <Error message={`Unhandled status ${submitPinStatus}`}/>
        )
    }

    isActive() {
        const {submitPinStatus} = this.props;
        if (submitPinStatus === RequestStatus.ACTIVE) {
            return true;
        }
        return false;
    }

    renderNextSignInForm() {
        const {dispatch,submitPinStatus,error,authToken} = this.props;
        const isActive = this.isActive()
        if (RequestStatus.SUCCESS == submitPinStatus) {
            const newUrlString ='http://localhost:1238/grant/' + authToken;
            setTimeout(window.location.replace(newUrlString, 2000));
            return <span>Redirecting to {newUrlString} ...</span>
        }

        return (
            <ContentBlock elevation={0}>
                <NextSignInForm
                    onSendPin={(values) => dispatch(doSendPin(values))}
                    onSubmitPin={(values) => dispatch(doSubmitPin(values))}
                    signInMessage={this.getSignInMessage()}
                    signinDomain={window.location.hostname}
                    isActive={isActive}
                />
            </ContentBlock>
        )
    }

    render() {
        return (
            <>
                <ContainerX AsContainer withLargeTopMargin backgroundColor={'paper'}>
                    <ContentBlockHeader
                        PageTitle={(
                            <Text variant="h4" gutterBottom>

                            </Text>
                        )}
                        TitleColor="textPrimary"
                        SubHeader={<FormattedMessage {...nextAuthenticationMessages.signInContainerSubHeader}/>}
                        heroTitle_X
                        heroMargin
                        hasDivider
                    />
                    <Grid container justifyContent="flex-start">
                        {this.renderNextSignInForm()}
                    </Grid>

                </ContainerX>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        authToken: state.mboxAndPin.authToken,
        submitPinStatus: state.mboxAndPin.submitPinStatus
    }
}

NextSignInContainer.propTypes = {
    location: PropTypes.object,
    onDoLogin: PropTypes.func.isRequired,
    submitPinStatus: PropTypes.object.isRequired,
    error: PropTypes.object
}
export default connect(mapStateToProps)(NextSignInContainer)
